import React, { useState } from "react";
import Contacts from "@/pages/contacts";
// import Australiainvestorvisaimport from "@/pages/australiainvestorvisaimport";
const Australiavisitvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/australiya.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
          {/* <div className="absolute bottom-5 left-5 text-3xl font-bold text-[#011473] drop-shadow-md">
          Visit Australia: Simple Steps to Your Visa
          </div> */}
        </div>
      </div>
      <div className="ml-8 md:ml-32 mt-10 w-3/4 text-left md:text-center text-3xl font-bold text-[#011473] drop-shadow-md">
  Visit Australia: Simple Steps to Your Visa
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row ">
        {/* Left Section: Image */}

        <div className="mb-8 flex xl:w-1/2 w-3/4 justify-center lg:mb-0">
          <img
            src="/visita.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-4">
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 mr-14 font-medium text-gray-700">
    <a className="text-black font-bold">  Visitor Visa (Subclass 600):</a> Suitable for travel durations of 3, 6, or 12 months.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 mr-14 font-medium text-gray-700">
      Offers various streams such as Tourist, Business and Sponsored Family visas.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 mr-14 font-medium text-gray-700">
    <a className="text-black font-bold">Electronic Travel Authority (Subclass 601):</a> Perfect for short-term trips.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 mr-14 font-medium text-gray-700">
      Available exclusively to citizens of eligible countries.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 mr-14 font-medium text-gray-700">
    <a className="text-black font-bold"> Visitor Visa (Subclass 651):</a> A free visa option for specific nationalities.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 mr-14 font-medium text-gray-700">
      Allows up to 3 months of travel for tourism or business purposes.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 mr-14 font-medium text-gray-700">
      Each visa type is tailored for specific travel needs and durations.
    </span>
  </div>
</div>


      </div>
    
      <div className="flex w-full flex-col items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center text-black rounded-md bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        <strong>Australia Visit Visa Overview: </strong>  
        An Australia Visit Visa is a popular option for individuals planning a holiday, visiting family and friends, or engaging in short business activities in Australia. To travel for these purposes, applying for a Tourist Visa (Australia) is essential. Below, we outline the key requirements to secure an Australian Visit Visa, commonly referred to as a ‘Tourist Visa Australia.’  
        <br />
        <strong>Eligibility and Duration: </strong>  
        - Australian Visitor Visas, including the ETA (Electronic Travel Authority) and standard Visitor Visa, are available to citizens of 45 approved countries.  
        - These visas permit a stay of up to three months for tourism, business, or transit purposes.  
        - Travelers who are not eligible for ETA/Visitor Visas or require extended stays can apply for a standard Australia Visit Visa.  
        <br />
        <strong>Why Choose an Australia Visit Visa?
          
          </strong> 
          <br></br> 
        - Ideal for holidays, family visits, or short-term business trips.  
        - Simplifies the process for travelers from approved countries.  
        - Offers flexibility for extended travel or alternative visa categories.  
        <br />
        For more personalized assistance, Visa World is here to guide you through every step of the application process, ensuring a smooth experience.  
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex w-2/2  md:w-1/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Why Choose an Australia Visit Visa?
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>

      <Contacts />
    </>
  );
};

export default Australiavisitvisa;
